import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

const Map = (props) => {
  const { setMapCenter, mapCenter } = props;
  /////----------------Google---Map
  //const libraries = ["places"];
  const [libraries] = useState(["places"]);
  const mapContainerStyle = {
    width: "100%",
    position: "relative",
    overflow: "hidden",
    /* margin-bottom: 21px; */
    height: "447px ",
    border: "3px solid #ddd ",
  };
  const center = {
    lat: 7.2905715, // default latitude
    lng: 80.6337262, // default longitude
  };
    ///----googleMapsAPI_key

  const { isLoaded, loadError } = useLoadScript({
    // googleMapsApiKey: "AIzaSyCqrujudljl8XJMUorzeCZX4m9ALeKaw0A",
    googleMapsApiKey:"AIzaSyCIpJxtSOEE6fCWr8Y_WkH72u2MTq0_1wo",
    libraries,
  });


  if (loadError) {
    return <div>Error loading maps</div>;
  }
  if (!isLoaded) {
    return <div>Loading maps</div>;
  }
  const handleMapClick = (event) => {
    // Update the map center when the map is clicked

    // setMapCenter({
    //   lat: event.latLng.lat(),
    //   lng: event.latLng.lng(),
    // });
    props.ChangeLocation(event);
  };
  const handleMarkerClick = () => {
    // Handle marker click event if needed
    console.log("Marker clicked!");
  };

  const onSearchBoxLoad = (ref) => {
    if (ref) {
      const searchBox = new window.google.maps.places.SearchBox(ref);
      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();
        console.log(ref.current, "Search", places);
        if (places.length === 0) {
          return;
        }

        const newCenter = {
          lat: places[0].geometry.location.lat(),
          lng: places[0].geometry.location.lng(),
        };
        //console.log(searchBox, "Placess" , newCenter);
        // Set the new map center
        //mapCenter.panTo(newCenter);
        setMapCenter({
          ...mapCenter,
          lat: newCenter.lat,
          lng: newCenter.lng,
        });
        // console.log(newCenter, "map");
        props.SearchedLocaitons(newCenter);
      });
    }
  };

  if (loadError) return "Error loading maps";
  if (!isLoaded) return "Loading maps";

  // // Function to get user's current location
  // const getUserLocation = () => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const userLocation = {
  //           lat: position.coords.latitude,
  //           lng: position.coords.longitude,
  //         };
  //         setMapCenter(userLocation);

  //       },
  //       (error) => {
  //         console.error("Error getting user location:", error);
  //         // Handle error, such as displaying a message to the user
  //       }
  //     );
  //   } else {
  //     console.error("Geolocation is not supported by this browser.");
  //     // Handle unsupported browser scenario
  //   }
  // };

  // const handleLocationClick = () => {
  //   // Ask for permission to get user's location
  //   if (navigator.permissions) {
  //     navigator.permissions
  //       .query({ name: "geolocation" })
  //       .then((result) => {
  //         if (result.state === "granted") {
  //           getUserLocation();
  //         } else if (result.state === "prompt") {
  //           // Permission prompt will be displayed to the user
  //           // Handle the prompt if needed
  //         } else if (result.state === "denied") {
  //           // User denied the location permission
  //           // Handle denied scenario, e.g., display a message or provide an alternative
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error querying permission:", error);
  //       });
  //   } else {
  //     console.error("Permissions API is not supported by this browser.");
  //     // Handle unsupported browser scenario
  //   }
  // };
  const getUserLocation = () => {
    if (navigator.geolocation) {
      console.log(navigator.geolocation, "navigator.geolocation");
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setMapCenter(userLocation); // Assuming you have a function to set map center
        },
        (error) => {
          console.error("Error getting geolocation:", error);
          if (error.code === error.PERMISSION_DENIED) {
            alert(
              "Access to geolocation was denied. Please enable it in your browser settings."
            );
          } else {
            alert("Error getting geolocation. Please try again later.");
          }
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      // Handle unsupported browser scenario
    }
  };

  


  // Function to handle location button click
  const handleLocationClick = () => {
    if (navigator.permissions) {
      console.log("gifusufhufhufuisu1");

      navigator.permissions
        .query({ name: "geolocation" })
        .then((result) => {
          console.log(result, "statuetuaygdyasud");
          if (result.state === "granted") {
            getUserLocation();
          } else if (result.state === "prompt") {
            alert("This app wants to access your location. Please allow.");

            // Call getCurrentPosition again after user interaction
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const { latitude, longitude } = position.coords;
                console.log("Latitude:", latitude);
                console.log("Longitude:", longitude);

                // Handle latitude and longitude data as needed
                const userLocation = {
                  lat: latitude,
                  lng: longitude,
                };
                setMapCenter(userLocation); // Assuming you have a function to set map center
              },
              (error) => {
                console.error("Error getting geolocation:", error);
                if (error.code === error.PERMISSION_DENIED) {
                  alert(
                    "Access to geolocation was denied. Please enable it in your browser settings."
                  );
                } else {
                  alert("Error getting geolocation. Please try again later.");
                }
              }
            );
          } else if (result.state === "denied") {
            const enableLocationMessage =
              "Location access is required for this feature. Please enable location services in your browser settings.";

            alert(enableLocationMessage);
          }
        })
        .catch((error) => {
          console.error("Error querying permission:", error);

          alert("Please enable location services in your browser settings.");
        });
    } else {
      console.error("Permissions API is not supported by this browser.");
      alert(
        "Your browser does not support location permissions. Please use a different browser."
      );
    }
  };
// document.querySelector('#getLocationClick').click();
  return (
    <>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={5}
        center={mapCenter}
        onClick={handleMapClick}
      >
        <Marker position={mapCenter} onClick={handleMarkerClick} />

        <div className="SearchBox">
          <input
            type="text"
            placeholder="Search places"
            className="SearchMaps"
            ref={onSearchBoxLoad}
            // style={{
            // position: "absolute",
            // top: 10,
            // left: 10,
            // zIndex: 1,
            // padding: "8px",
            // }}
          />
        </div>
      </GoogleMap>

      <button
        onClick={handleLocationClick}
        class="  SaveBtn"
         id="getLocationClick"
        style={{ marginTop: "20px" }}
      >
        Get My Location
      </button>
    </>
  );
};

export default Map;
